var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-overlay",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("button", { staticClass: "modal-close", on: { click: _vm.close } }, [
          _vm._v("×"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-body" }, [
          _c(
            "div",
            { attrs: { id: "modal-online-scheduling" } },
            [
              _c("page-online-scheduling", {
                attrs: { "dealer-id": _vm.dealerId },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }